<template>
    <div>
        <b-modal size="xl" id="modal-prevent-closing" centered class="header-modal" no-close-on-backdrop hide-footer ref="modal-view-document">
            <div class="modal-view-document__body container wrap-form-create-update-chapter">

                <div>
        <div class="row margin-top-10">
            <div class="col-md-12 wrap-page">
                <div class="full-width"
                    v-if="dataDetailExcercise.typeUploadExcercise == 5 || dataDetailExcercise.typeUploadExcercise == 6">
                    <embed :src="apiUrl + dataDetailExcercise.path" class="ember-pdf" />
                </div>
                <div
                    v-if="dataDetailExcercise.typeUploadExcercise == 1 || dataDetailExcercise.typeUploadExcercise == 2">
                    <div class="item-question-answer"
                        v-for="(dataSource, indexQuestion) of dataDetailExcercise.listExcerciseQuestionClassSchool" :key="indexQuestion">
                        <h5>Câu {{ indexQuestion+1 }}</h5>
                        <PreviewQuestion :id="`question_${indexQuestion}`" :dataSource="dataSource.question" :location="indexQuestion"
                                :questions="dataSource.question.answers"
                                :isDontShowResultSaved="false" :disabled="true"/>
                        <!-- <div class="question" v-html="dataSource.question.content">

                        </div>
                        <div v-for="(item, indexanswers) of dataSource.question.answers" :key="indexanswers">
                                    <MultipleChoiceNew v-if="dataSource.type === TYPE_RADIO" :dataSource="item"
                                        :nameField="`answer_${dataSource.id}`" :location="indexanswers"
                                        :parent="dataSource" :valueSelected="item.correct"
                                        :answerContent="item.content"
                                        :statusUserExcercise="2"  />
                                </div> -->
                    </div>
                </div>
                <div
                    v-else-if="dataDetailExcercise.typeUploadExcercise == 3 || dataDetailExcercise.typeUploadExcercise == 4">
                    <div class="item-question-answer"
                        v-for="(dataSource, indexQuestion) of dataDetailExcercise.listExcerciseQuestionClassSchool" :key="indexQuestion">
                        <h5>Câu {{ indexQuestion+1 }}</h5>
                        <div class="question" v-html="dataSource.content">

                        </div>
                        <div v-for="(item, indexanswers) of dataSource.answers" :key="indexanswers">
                                    <MultipleChoiceNew v-if="dataSource.type === TYPE_RADIO" :dataSource="item"
                                        :nameField="`answer_${dataSource.id}`" :location="indexanswers"
                                        :parent="dataSource" :valueSelected="item.correct"
                                        :answerContent="item.content"
                                        :statusUserExcercise="2"  />
                                </div>
                    </div>
                </div>
            </div>
        </div>

    </div>


                <div class="modal__actions text-right">
                    <a href="javascript:;" class="primary-color-txt font-size-17 btn-cancel" @click="handleHideModal">
                        Đóng
                        <img class="icon-close" src="@/assets/img/x.png" alt="" />
                    </a>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import MultipleChoiceNew from './../../question/preview-question/answers/multiple-choice/MultipleChoiceNew.vue'
import PreviewQuestion from '@/modules/question/preview-question-excercise-thieu/PreviewQuestion.vue'
import { getDetailExcercise } from './../_api/LessonClassSchoolServices'
import { APP_CONFIG } from '@/utils/constants'
import store from '@/modules/question/preview-question-excercise-thieu/_store'
import { STORE_KEY as STORE_KEY_QUESTION, TYPE_GROUP, TYPE_DRAW_SHAPE_ANSWER, TYPE_DOWN_ANSWER, TYPE_FILL_BLANK, TYPE_SELECT, TYPE_MATH_COL } from '@/modules/question/preview-question-excercise-thieu/_store/constants'
export default {
    name: "ModalViewExam",
    props:{
        lessonClassSchoolId:{
            type:Number,
            default:0
        }
    },
    components:{
        MultipleChoiceNew,
        PreviewQuestion
    },
    data() {
        return {
            TYPE_RADIO: 'radio',
                        TYPE_CHECKBOX: 'checkbox',
                        TYPE_TRUE_FALSE_NO: 'answer_t_f_no',
                        TYPE_MATH_COL: 'math_col',
                        TYPE_FILL_BLANK: 'fill_blank',
                        TYPE_FILL_SENTENCE: 'fill_sentence',
                        TYPE_SELECT: 'select',
                        TYPE_DOWN_ANSWER: 'down_answer',
                        TYPE_CIRCLE_ANSWER: 'circle_answer',
                        TYPE_X_MARK: 'x_mark_answer',
                        TYPE_DRAW_SHAPE_ANSWER: 'draw_shape_answer',
                        TYPE_GROUP: 'group',
                        TYPE_FILL_INPUT_IMG: 'fill_input_img',
            dataDetailExcercise: {},
            examId: 0,
            apiUrl: APP_CONFIG.appUrl + 'lessons/',
        }
    },
    mounted(){
        this.handleShowModal()
        this.getDetailLessonClassSchool()
    },
    created() {
        if (!(STORE_KEY_QUESTION in this.$store._modules.root._children)) {
            this.$store.registerModule(STORE_KEY_QUESTION, store);
        }
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
        
    },
    methods: {
        getDetailLessonClassSchool() {
            let self = this
            getDetailExcercise(this.lessonClassSchoolId).then(res => {
                if (res && res.data && !res.errors) {
                    self.dataDetailExcercise = res.data
                    
                }
            })
        },
        handleHideModal() {
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-view-document'].show()
        }
    }
}
</script>
<style lang="scss" scoped>
.item-question-answer{
    margin-top: 10px;
    padding: 10px;
    background: #e1effe;
    border-radius: 10px;
    border: 1px solid #b1b1b1;
    margin-bottom: 10px;
}
.icon-close{
    width: 15px;
}
.wrap-view-document{
    margin-top: 10px;
}
.modal-content {
    background-color: red;
}

.modal-view-document__body {
    min-height: calc(100vh - 10rem);
    padding: 20px;
    background-color: white;

    .modal__actions{
        position: absolute;
        top: 0px;
        right: 0px;
        padding: 0px;
        .btn-delete{
            color: white;
            background: #fe0201;
            padding: 5px 20px 5px 20px;
            border-radius: 15px;
            font-family: sans-serif;
        }
        .btn-cancel{
            color: black;
            margin-right: 10px;
            font-family: sans-serif;
        }
    }
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-between {
    justify-content: center
}
</style>